import { NgClass, NgIf } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { ClickedOutsideModule } from 'src/app/directives/clicked-outside/clicked-outside.module';
import { ShareEntitiesEnums } from 'src/app/enums/chat-enums';
import { UserRoles } from 'src/app/enums/general-enums';
import { HandleShowMoreModule } from 'src/app/pipes/handle-show-more/handle-show-more.module';
import { TimeAgoModule } from 'src/app/pipes/time-ago/time-ago.module';
import { UiHelperService } from 'src/app/services/helpers/ui-helper.service';
import { FollowedUsersPost } from 'src/app/services/http-services/home/home-interfaces';
import { PostsHttpService } from 'src/app/services/http-services/posts/posts-http.service';
import {CheckActiveRoleModule} from '../../../../pipes/check-active-role/check-active-role.module';
import {MatchLocaleModule} from '../../../../pipes/match-locale/match-locale.module';

@Component({
  selector: 'app-latest-post',
  standalone: true,
  imports: [TimeAgoModule, NgIf, HandleShowMoreModule, RouterModule, ClickedOutsideModule, NgClass, TranslateModule, CheckActiveRoleModule, MatchLocaleModule],
  templateUrl: './latest-post.component.html',
})
export class LatestPostComponent implements OnInit {
  @Input() post!: FollowedUsersPost;
  @Output() isSharePostModalOpen = new EventEmitter<boolean>();
  @Output() isReportPostModalOpen = new EventEmitter<boolean>();
  @Output() selectedPost = new EventEmitter<FollowedUsersPost>();
  isShowMore = false;
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  postUrl = '';
  protected readonly UserRoles = UserRoles;
  protected readonly ShareEntitiesEnums = ShareEntitiesEnums;
  isCallToActionModal = false;
  isDeletePostModalOpen = false;
  @ViewChild('viewMoreBtn') viewMoreBtn: ElementRef | undefined;

  constructor(
    private renderer: Renderer2,
    private uiHelperService: UiHelperService,
    private postsHttpService: PostsHttpService,
    private meta: Meta,
    private router: Router
  ) { }

  ngOnInit(): void {
    let ogImage;
    if (this.post.lyst && this.post.lyst.lyst_image_url !== null) {
      ogImage = this.post.lyst.lyst_image_url;
    } else if (this.post.lyst_item && this.post.lyst_item.lyst_item_image_url !== null) {
      ogImage = this.post.lyst_item.lyst_item_image_url;
    } else {
      ogImage = 'assets/images/og-image.png'
    }
    this.meta.updateTag({
      property: 'og:title',
      content: `${this.post.user.username} on TheLysts: ${this.post.content.slice(0, 20)}...`
    });
    this.meta.updateTag({
      property: 'og:description',
      content: `${this.post.user.username} on TheLysts: ${this.post.content.slice(0, 20)}...`
    });
    this.meta.updateTag({
      property: 'og:image',
      content: ogImage
    });
    this.meta.updateTag({
      property: 'og:url', content: this.router.url
    });
  }

  listenToClickViewMoreBtn(): void {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.uiHelperService.checkIfClickedOutsideOfTheElement(this.viewMoreBtn, this.viewMoreBtn, e)) {
        this.isCallToActionModal = false;
      }
    });
  }

  onCallActionReportPost(event: any): void {
    event.stopPropagation();
    this.isCallToActionModal = false;
    this.isReportPostModalOpen.emit(true);
    this.selectedPost.emit(this.post);
  }
  onCallActionSharePost(event: any): void {
    event.stopPropagation();
    this.isCallToActionModal = false;
    this.isSharePostModalOpen.emit(true);
    this.selectedPost.emit(this.post);
  }

  togglePostLike(event: any): void {
    event.stopPropagation();
    this.postsHttpService.togglePostLike({ postId: this.post.id }).then(res => {
      this.post.am_i_liked_this = res.data.am_i_liked_this;
      this.post.likes_count = res.data.likes_count;
    });
  }
}
